import React, { useState } from 'react';
import { getCoreRowModel, getPaginationRowModel, useReactTable } from '@tanstack/react-table';
import { TablaCotizacionesServiciosVista } from '../vista/tablaCotizacionesServiciosVista';
import { columnasTablaCotizacionesServicios } from '../vista/constantesTablaCotizacionesServicios';
import type { ICotizacionServiciosResumen } from '../../../modelos/CotizadorServicios/entidades/ICotizacionServicios';
import { useConfirmacion } from '../../../globales/contextos/confirmacionContext';
import { useNotificaciones } from '../../../globales/contextos/notificationContext';
import { EnumTipoNotificacion } from '../../../globales/interfaces';

interface ListaCotizacionesServiciosCVProps {
    cotizaciones: ICotizacionServiciosResumen[];
    alCrearNueva: () => void;
    alEditar: (id: string) => void;
    alEliminar: (id: string) => void;
    alRefrescar: () => void;
}

const TAMANO_PAGINA = 8;

/** Acciones del listado: editar, PDF y eliminar con confirmación. */
export const ListaCotizacionesServiciosCV: React.FC<ListaCotizacionesServiciosCVProps> = ({ cotizaciones, alCrearNueva, alEditar, alEliminar, alRefrescar }) => {
    const { confirmar } = useConfirmacion();
    const { mostrarNotificacion } = useNotificaciones();
    const [paginacion, setPaginacion] = useState({ pageIndex: 0, pageSize: TAMANO_PAGINA });

    const columnas = columnasTablaCotizacionesServicios({
        alEditar: (cotizacion) => alEditar(cotizacion.Id),
        alGenerarPdf: () => {
            // TODO back: previsualizar el PDF de la cotización.
            mostrarNotificacion(EnumTipoNotificacion.Information, 'Pendiente', 'El PDF se habilitará al conectar el servicio del cotizador.', 3000);
        },
        alEliminar: async (cotizacion) => {
            const confirmado = await confirmar({
                titulo: 'Eliminar Cotización',
                mensaje: `¿Estás seguro de que deseas eliminar la cotización de ${cotizacion.Proyecto}? Esta acción no se puede deshacer.`,
                tipo: EnumTipoNotificacion.Warning,
                textoAceptar: 'Eliminar',
                textoCancelar: 'Cancelar'
            });
            if (confirmado) alEliminar(cotizacion.Id);
        }
    });

    const tabla = useReactTable({
        data: cotizaciones,
        columns: columnas,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getRowId: fila => fila.Id,
        state: { pagination: paginacion },
        onPaginationChange: setPaginacion
    });

    return <TablaCotizacionesServiciosVista tabla={tabla} alCrearNueva={alCrearNueva} alRefrescar={alRefrescar} />;
};
